import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { Grid, Icon } from 'semantic-ui-react';
import _ from 'lodash';

import { ProductionRecipeLeftoverEnum as ProdRecipeLeftoverFields } from 'Common/FieldEnum';
import { RecipeItemList } from 'Common/Components/RecipeSearch/RecipeItemList';
import * as EditProductionSelectors from 'Pages/manageproduction/state/editproduction/selectors';

class RecipeLeftoversPanel extends React.Component {
  static propTypes = {
    onSearchCloseClick: PropTypes.func.isRequired,
    onAddRecipe: PropTypes.func.isRequired,
  };

  state = {
    position: { x: 0, y: 0 },
  };

  componentDidMount() {
    this.setState({ position: this.getCenterPosition() });
  }

  handleDrag = (e, { x, y }) => {
    this.setState({ position: { x, y } });
  };

  getCenterPosition = () => {
    const x = Math.max(
      (document.documentElement.clientWidth - 350) / 2,
      (window.innerWidth - 350) / 2 || 0
    );
    const innerHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const y = innerHeight > 768 ? (innerHeight - 850) / 2 : 0;
    return { x, y };
  };

  static get recipeItemFooterItems() {
    return [
      {
        fieldName: ProdRecipeLeftoverFields.Id,
        render: ({ value, ...rest }) => <span {...rest}>R#: {value}</span>,
      },
      {
        fieldName: ProdRecipeLeftoverFields.Leftovers,
        render: ({ value, ...rest }) => {
          const total = _.sumBy(
            value,
            lo => lo[ProdRecipeLeftoverFields.Portions] || 0
          );

          return (
            <span {...rest} title={total}>
              {`Leftovers: ${total}`}
            </span>
          );
        },
      },
    ];
  }

  addLeftovers = index => {
    const { leftoversList, onAddRecipe } = this.props;
    const leftoverRecipe = leftoversList[index];

    onAddRecipe(leftoverRecipe);
  };

  render() {
    const { onSearchCloseClick, leftoversList } = this.props;
    const { position } = this.state;

    return (
      <Draggable
        handle=".rs-header-row"
        bounds="parent"
        position={position}
        onDrag={this.handleDrag}
      >
        <div className="rs">
          <div className="rs-container">
            <Grid padded>
              <Grid.Row className="rs-header-row">
                <Grid.Column>
                  <div className="rs-header">
                    Leftover Recipes
                    <Icon
                      className="rs-close"
                      name="close"
                      color="red"
                      size="large"
                      onMouseDown={this.onRecipeSearchIconsMouseDown}
                      onClick={onSearchCloseClick}
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <RecipeItemList
              enableDnD={false}
              items={leftoversList}
              recipeItemProps={{
                showIcon: false,
                bordered: true,
                onAddRecipe: this.addLeftovers,
                footerItems: RecipeLeftoversPanel.recipeItemFooterItems,
              }}
              style={{ paddingTop: 4 }}
            />
          </div>
        </div>
      </Draggable>
    );
  }
}

const mapStateToProps = state => ({
  leftoversList: EditProductionSelectors.getAvailableLeftovers(state),
});

RecipeLeftoversPanel = connect(mapStateToProps)(RecipeLeftoversPanel);

export { RecipeLeftoversPanel };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/RecipeLeftoversPanel.js